String.prototype.decodeEscapeSequence = function () {
  return this.replace(/\\x([0-9A-Fa-f]{2})/g, function () {
    return String.fromCharCode(parseInt(arguments[1], 16));
  });
};

String.prototype.hexHtmlToString = function () {
  var REG_HEX = /&#x([a-fA-F0-9]+);/g;
  return this.replace(REG_HEX, function (match, grp) {
    var num = parseInt(grp, 16);
    return String.fromCharCode(num);
  });
};

export const humanize = (str) => {
  if (typeof str === 'undefined' || str === null) {
    return str;
  }
  var frags = str.trim().split('_');
  for (let i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
};

export const toTitleCase = (str) => {
  if (typeof str !== 'string' || str === null || str.length === 0) {
    return str;
  }
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const toTitleCaseEveryWord = (str) => {
  if (typeof str !== 'string' || str === null || str.length === 0) {
    return str;
  }
  const regex = /_/gi;
  return str.replace(regex, ' ').replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const numberFormat = (number, locale) => {
  if (typeof number === 'undefined' || number === null) return number;
  if (typeof locale === 'undefined' || locale === null)
    locale = window.navigator.userLanguage || window.navigator.language;
  if (number > 0) return new Intl.NumberFormat(locale).format(number);
  return number;
};

export const strtok = function (str, tokeniser) {
  if (typeof str === 'undefined' || str === null || str.length === 0) {
    return null;
  }
  if (
    typeof tokeniser === 'undefined' ||
    tokeniser === null ||
    tokeniser.length === 0
  ) {
    tokeniser = ',';
  }
  return str.split(tokeniser)[0].trim();
};

export const strtokLen = function (str, tokeniser, len) {
  if (typeof str === 'undefined' || str === null || str.length === 0) {
    return null;
  }
  if (
    typeof tokeniser === 'undefined' ||
    tokeniser === null ||
    tokeniser.length === 0
  ) {
    tokeniser = ',';
  }
  if (len > str.split(tokeniser).length) len = str.split(tokeniser).length;
  return str
    .split(tokeniser)
    .slice(0, len)
    .map((x) => x.trim())
    .join(' ');
};

export const wordWrap = (str, length) => {
  if (typeof str === 'undefined' || str === null) {
    return str;
  }
  if (str.length > length) return str.substr(0, length) + '....';
  else return str;
};

export const nl2br = (str) => {
  if (typeof str !== 'string' || str === null || str.length === 0) {
    return '';
  }
  return str.split('\n').map((item, key) => (
    <span key={key}>
      {item}
      <br />
    </span>
  ));
};

export const localTrim = (str) => {
  if (typeof str != 'string' || str === null || str.length === 0) {
    return str;
  }
  return str.trim();
};

export const retProperVal = (param) => {
  if (typeof param === 'undefined' || param === undefined || param === null) {
    return null;
  }

  if (typeof param === 'string') {
    // lets trim it first
    param = localTrim(param);
    if (param === null || param.length === 0) {
      return null;
    }
  } else if (typeof param === 'number') {
    return param;
  } else {
    if (String(param).trim().length === 0) return null;
  }

  return param;
};

export const unEscapeHTML = (safe) => {
  if (typeof safe != 'string' || safe === null || safe.length === 0) {
    return safe;
  }
  return safe
    .decodeEscapeSequence()
    .hexHtmlToString()
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#34;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#039;/g, "'");
};

export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};

const edu_level = [
  'Not studying',
  'School',
  'Bachelors',
  'Masters',
  'PhD',
  'Post Doc',
];
const enrol_level = [
  'Elementary School',
  'Middle School',
  'High School',
  'University',
  'Not in School',
];
const highest_rep_level = ['Regional', 'National', 'International'];
const ref_type = ['Teacher', 'Coach', 'Manager', 'Teammate'];
const media_type = ['weburl', 'video', 'audio', 'video'];
const occupations = [
  'Minor Athlete',
  'Athlete',
  'Guardian',
  'Coach',
  'Team Manager',
  'Club Manager',
  'Scout',
  'Agent',
];
const gender_vals = ['N/A', 'Female', 'Male'];

export const getCommonStringVals = (type, key) => {
  switch (type) {
    case 'edu_level':
      return edu_level[key];
    case 'highest_rep_level':
      return highest_rep_level[key];
    case 'ref_type':
      return ref_type[key];
    case 'media_type':
      return media_type[key];
    case 'enrol_level':
      return enrol_level[key];
    case 'occupations':
      return occupations[key - 1];
    case 'gender':
      return gender_vals[key];
  }
};
